import { Component, OnInit, OnDestroy } from '@angular/core';
import {  Subscription } from 'rxjs';
import { AuthService } from '@authentication/auth.service';
import { UsuarioService } from '@account/usuario.service';
import {  NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ModalConfirmComponent } from '@shared/generic-modals/modal-confirm.component';
import { Usuario } from '@shared/models/despacho/Usuario';
import { Aeroplanta } from '@shared/models/despacho/Aeroplanta';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { TipoUsuario } from '@shared/enums/tipoUsuario';
import { environment } from '@environments';
import { AccionLogin } from '@shared/enums/AccionLogin';
import { MessageService } from '../message.service';
import { NotificacionesUsuarioComponent } from '../notificaciones-usuario/notificaciones-usuario.component';
import { SignalRService } from '@shared/signal-r.service';
import { NotificacionesService } from '@abm/notificacion/notificaciones.service';
import { AboutComponent } from '@shell/about/about.component';

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss']
})
export class NavbarComponent implements OnInit, OnDestroy {
  TipoUsuario = TipoUsuario;

  enumAccionLogin = AccionLogin;
  seteandoAeroplanta: boolean = false
  usuario: Usuario;
  aeroplantas: Aeroplanta[];
  nombresOperador: string;
  tipoUsuario: string;
  isAuthenticated: boolean;
  accionLogin: AccionLogin;

  isAuthenticatedSubscription: Subscription;
  usuarioSubscription: Subscription;
  accionLoginSubscription: Subscription;

  notificacionesNoLeidas: number = 0;
  notificacionNavbarSubscription: Subscription;

  navBarForm = new FormGroup({
    aeroplantaFormControl: new FormControl(null, Validators.required)
  });

  _seeHow: boolean = false;

  constructor(  public authService: AuthService,
                private usuarioService: UsuarioService, 
                private notificacionesService: NotificacionesService,
                private modalService: NgbModal, 
                private messageService: MessageService,
                private signalRService: SignalRService) {

    this.accionLoginSubscription = this.authService.authAccionLogin$.subscribe(accionLogin => {
      if (accionLogin)
        this.accionLogin = accionLogin;
    });

    this.notificacionNavbarSubscription = this.signalRService.cantidadNuevasNotificaciones$().subscribe(notificacion => {
      if(usuarioService.getIdUsuario() && notificacion.usuarios.includes(usuarioService.getIdUsuario())){
        this.notificacionesNoLeidas = Number(notificacion.detalle);
      }
    });
  }

  ngOnInit() {

    this.isAuthenticatedSubscription = this.authService.authNavStatus$.subscribe(status => {
      this.isAuthenticated = status;
    });

    this.usuarioSubscription = this.usuarioService.usuario$.subscribe(usr => {
      if (usr == null) return;

      this.usuario = usr;
      
      if (this.authService.isAuthenticated()) this.iniciarDatosNavbar();
    });
  }

  ngOnDestroy() {
    this.isAuthenticatedSubscription.unsubscribe();
    this.usuarioSubscription.unsubscribe();
  }

  iniciarDatosNavbar(){
    this.nombresOperador = this.usuario.nombresCompletos;
    //this.tipoUsuario = this.getDescripcionTipoUsuario(this.usuario.tipoUsuario);
    let string="";
    for (const item of this.usuarioService.getRoles()) {
      string=string.concat(this.getDescripcionTipoUsuario(item)).concat("\n");
    }
    this.tipoUsuario = string;
    this.procesarAeroplantas(this.usuario.aeroplantas);
    this.obtenerCantidadNotificacionesNoLeidas();
  }

  get nombreOperador() {
    if (this.usuarioService.getNombresOperador())
      return this.usuarioService.getNombresOperador();
    else if (this.nombresOperador)
      return this.nombresOperador;
    return '';
  }

  get idAeroplantaActual() {
    const userAep = this.usuarioService.getAeroplantaActual();
    return userAep ? userAep.id : null;
  }

  procesarAeroplantas(aeroplantas) {

    this.aeroplantas = aeroplantas.filter(a => a.validada);
    this.aeroplantas.sort((a, b) => (a.codigoAeroplanta > b.codigoAeroplanta) ? 1 : -1);

    if (this.aeroplantas.length == 0) {
      this.messageService.showErrorMessage("No posee ninguna aeroplanta asociada.");
    } else {
      if (!this.seteandoAeroplanta) {
        this.aeroplantaControl.patchValue(this.aeroplantas[0].codigoAeroplanta);
        this.usuarioService.setAeroplantaInicial(this.aeroplantas[0]);
      }
    }
  }

  obtenerCantidadNotificacionesNoLeidas(){
    this.notificacionesService.getCantidadNotificacionesNoLeidas()
      .subscribe(cantidadNoLeidas => {
        this.notificacionesNoLeidas = cantidadNoLeidas
      });
  }
  
  setAeroplanta() {
    const aepSeleccionada = this.aeroplantaControl.value;
    this.aeroplantaControl.setValue(aepSeleccionada);
    this.usuarioService.setAeroplanta(aepSeleccionada);    
  }

  signout(seeHow?: boolean) {
    if (!seeHow) {
      const modalRef = this.modalService.open(ModalConfirmComponent, { centered: true });
      modalRef.componentInstance.mensaje = "¿Realmente desea cerrar sesión?"; // should be the id
      modalRef.componentInstance.textoSi = "Cerrar sesión";
      modalRef.componentInstance.textoNo = "Volver";
      modalRef.result.then(() => {
        this.authService.signout();
        location.assign("#");
      });
    } else {
      sessionStorage.removeItem('seeHow');
      location.assign("#");
    }
  }

  abouting() {
    const modal = this.modalService.open(AboutComponent, { centered: true });
    modal.result.then(() => {
      console.log('hola');
    });
  }

  toggleSeeHow() {
    this._seeHow = !this._seeHow;
  }

  selectRole(item) {
    this._seeHow = false;
    sessionStorage.setItem('seeHow', item);
    location.assign("#");
  }

  getDescripcionTipoUsuario(n) {
    return TipoUsuario[n];
  }

  verNotificaciones(){
    this.notificacionesNoLeidas = 0;
    this.modalService.open(NotificacionesUsuarioComponent, { size: 'lg', windowClass: 'modalNotificaciones', backdrop: 'static' })   
  }

  get listRoles(): any[] {
    return Object.keys(TipoUsuario)
      .filter(key => isNaN(Number(key)))
      .sort((a, b) => a.localeCompare(b));
  }

  get showMenu(): boolean {
    return this.isAuthenticated && this.aeroplantas != null;
  }

  get aeroplantaControl() {
    return this.navBarForm.get('aeroplantaFormControl');
  }

  get inProduction(): boolean {
    return environment.name === 'production';
  }

  get inSeeHow(): boolean {
    return sessionStorage.getItem('seeHow')?.length > 0;
  }
}
